import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/style/base.scss'
import '@/plugins'
import '@/configs/config'
Vue.config.productionTip = false
new Vue({
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    isWx() {
      const ua = window.navigator.userAgent
      if (ua.includes('MicroMessenger')) {
        return true
      } else {
        return false
      }
    }
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
